import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Header from "../../Layouts/Header";

class AdmissionStatus extends Component{
  constructor(props){
    super(props);
    this.state={
    	status : "",
    	num_days: 7,
    	ins_name : sessionStorage.getItem("ins_name"),
    }
  }

  componentDidMount(){
  	  var data = JSON.parse( localStorage.getItem("stuData") );
      this.setState({
      	 name : data && data.name || "",
      	 course_name : data && data.course || "",
      	 batch_name: data && data.batch || "",
      	 app_no : data && data.application_nb || "",
      	 status: data && data.state || "",
      	 fee : data && data.fee || "0"
      })
      localStorage.removeItem("stuData");
  }

  render(){
  	 const { ins_name, status, fee, app_no, name, course_name, batch_name, num_days } = this.state;
  	 const { t } = this.props;
  	 return(
  	  <>
       <Header data={"Status"} />
  	 	<div style={{ 
      				background: "#03204e",
					/*background: "-webkit-linear-gradient(to right, #03204e, #348F50)",
					background: "linear-gradient(to right, #03204e, #348F50)"*/
		}}>
		 <br />
		  {
		  	status === "FeeDue" ?
			  <div className="card mb-3 ml-5 mr-5 mt-5" >
			      <div className="success-msg">
						<h3 className="pt-5 ml-5"><strong>{t("msg_hi")} {name},</strong></h3>
						<h5 className="mt-2 ml-5"><strong>{t("app_no")}:{app_no}</strong>  {t("msg_req")} <strong>{course_name}</strong> {t("msg_batch")} <strong>{batch_name}</strong>, <br />
							{t("msg_pay_fee")} <strong>E£ {fee}</strong> {t("msg_exp")} <strong>{num_days} {t("msg_days")} </strong>, <br />
							{t("msg_prof")} 
						</h5>
						<h5 className="mt-2 ml-5">{t("msg_wel")} {ins_name} {t("msg_traine")}</h5> 
						<h5 className="mt-5 ml-5 mb-5"><strong>{t("msg_college")}</strong><br />
							<strong>{t("msg_dir")}</strong>
						</h5> 
				  </div>
			   </div>
			   :
			    <div className="card success-msg mb-3 ml-5 mr-5  mt-5" >
					<h3 className="pt-5 ml-5"><strong>{t("msg_hi")} {name},</strong></h3>
					<h5 className="mt-2 ml-5"><strong>{t("app_no")}:{app_no}</strong> {t("msg_wait")} <strong>{course_name}</strong> .<br />
						 {t("msg_cert")}<br /> 
						 {t("msg_contact_info")}
					</h5>
					<h5 className="mt-2 ml-5">{t("msg_enrol")}</h5> 
					<h5 className="mt-5 ml-5 mb-5"><strong>{t("msg_college")}</strong><br />
							<strong>{t("msg_dir")}</strong>
					</h5> 
			   </div>
			}

		  <br /><br />
  	 	</div>
  	  </>
  	 )
  }
}

export default withTranslation() (AdmissionStatus)